import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getPreferredLocale, debugAllCookies } from '../../utils/localeUtils';
import { locales, defaultLocale } from '../../../i18n';

const LocaleDetector = () => {
  const router = useRouter();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    // Only run this check on client-side initial load
    if (hasChecked || typeof window === 'undefined') return;

    const API_BASE = 'https://www.dropbox.com';
    const checkAndRedirectLocale = async () => {
      debugAllCookies();
      // Fetch current locale from API
      let apiLocale = null;
      try {
        const res = await fetch(`${API_BASE}/cms/get_locale`, { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          apiLocale = data?.locale;
        }
      } catch (e) {
        console.error('Error fetching locale from API:', e);
      }

      const preferredLocale = getPreferredLocale();
      const currentLocale = router.locale || defaultLocale;
      const effectiveLocale = apiLocale || preferredLocale || currentLocale;

      console.log(`Current locale: ${currentLocale}`);
      console.log(`API locale: ${apiLocale}`);
      console.log(`Preferred locale from cookie: ${preferredLocale}`);

      // If we have a preferred locale and it's different from API locale
      if (
        preferredLocale &&
        preferredLocale !== apiLocale &&
        locales.includes(preferredLocale)
      ) {
        // Set locale via API
        try {
          const setRes = await fetch(`${API_BASE}/cms/set_locale`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ locale: preferredLocale })
          });
          if (setRes.ok) {
            console.log(`Locale set via API: ${preferredLocale}`);
            // Redirect to the preferred locale
            const currentPath = router.asPath;
            router.push(currentPath, currentPath, { locale: preferredLocale });
          } else {
            console.error('Failed to set locale via API');
          }
        } catch (e) {
          console.error('Error setting locale via API:', e);
        }
      }
      setHasChecked(true);
    };

    // Small delay to ensure router is ready
    const timer = setTimeout(() => {
      checkAndRedirectLocale();
    }, 100);
    return () => clearTimeout(timer);
  }, [router, hasChecked]);

  return null; // This component doesn't render anything
};

export default LocaleDetector;